import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { BONUSES } from '../data/content';
export function Bonuses() {
  return <section className="bg-ink py-10 sm:py-12" aria-labelledby="bonuses-title" data-id="element-15" data-mp="av370wfflb2q">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-8" data-id="element-16" data-mp="asz34ehj8c2g">
        <SectionHeading eyebrow="Included With Your Order" title="5 Professional Bonuses Included" subtitle="Additional practical resources designed to make your day-to-day coaching even easier." data-id="element-17" data-mp="fsv92j9sidkn" />

        <ul className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-5 lg:gap-4" data-id="element-18" data-mp="5tnkt11ioyir">
          {BONUSES.map((bonus, index) => <li key={bonus.title} className={`flex h-full flex-col rounded-lg border border-line bg-panel p-3.5 sm:p-4 ${index === BONUSES.length - 1 ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-19" data-mp="3t0g5mepnicdl" data-mpi={index}>
              <div className="flex items-center justify-between gap-2" data-id="element-20" data-mp="1r8jtp3zkn0ia">
                <span className="flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.2em] text-mutedtext sm:text-[10px]" data-id="element-21" data-mp="3id54j69013as">
                  <GiftIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-22" data-mp="3ddipcr9m1czc" />
                  Bonus {bonus.number}
                </span>
                <span className="rounded-full bg-gold/15 px-1.5 py-0.5 text-[8.5px] font-bold uppercase tracking-[0.12em] text-gold sm:text-[9px]" data-id="element-23" data-mp="3n67ocmnz4yds">
                  Included
                </span>
              </div>
              <h3 className="mt-2 font-display text-[14px] font-bold uppercase leading-[1.1] tracking-wide text-cream sm:text-[16px]" data-id="element-24" data-mp="2ui23lzwx79dy">
                {bonus.title}
              </h3>
              <p className="mt-1.5 text-[11.5px] leading-snug text-mutedtext sm:text-[13px]" data-id="element-25" data-mp="33g4agw3c4w95">
                {bonus.body}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}